export const loadingPlaceholder = 'loading...';
export const toastSelectDifferentTime = 'You must suggest a different time.';
export const toastTimeAlreadySelected = 'You already selected this time.';
export const toastUnableToGuaranteeTime = 'We can not guarantee this date! Please react out to support for help.';
export const cardTitle = 'Suggest a new date and time?';
export const addDateTime = 'add this date/time';
export const suggestTimesText = 'suggest new times';
export const cardDescription =
	'Add up to two alternate times that this service might work better for you. The client will get notified of your request and can accept or reject these suggestions.';
